import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { useTranslation } from 'react-i18next'; // Import useTranslation

const NoPage = () => {
  const lang = useLanguage();
  const { t } = useTranslation(); // Get translation hook

  useEffect(() => {
    document.title = t('noPage.title');
  }, [t]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>{t('noPage.heading')}</h1>
      <p>{t('noPage.description')}</p>
      <Link to={`/${lang}`}>Go to Home</Link>
    </div>
  );
};

export default NoPage;
